import { graphql } from '@/gql';
import type { UpdateCallerActiveHoursMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateCallerActiveHours = async ({ callerId, data }: UpdateCallerActiveHoursMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      callerId,
      data,
    },
    mutation: graphql(`
      mutation UpdateCallerActiveHours($callerId: String!, $data: CallerActiveHoursInput) {
        updateCallerActiveHours(callerId: $callerId, data: $data) {
          callerId
          days
          start
          end
        }
      }
    `),
  });

  return response.data?.updateCallerActiveHours;
};
